import React from 'react';
import styled from 'styled-components';
import { Page, PageContent } from '@style/Shared';
import Site from '@client/store/Site';
import { Breakpoints, Colors } from '@client/style/Variables';
import Functions from '@client/style/Functions';
import { CommonBoldText, CommonTitle } from '@client/style/Text';
import { SquareButton } from '@client/modules/shared/SquareButton';
import { TextStyle } from '@client/style/TextStyles';

const StyledPage = styled(Page)`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const StyledCommonTitle = styled(CommonTitle)`
	color: ${Colors.darkText};
	${TextStyle.size('p1')}
	max-width: 400px;

	${Functions.breakpoint(Breakpoints.laptop)} {
		${TextStyle.size('h3')}
		max-width: 800px;
	}
`;

const StyledCommonText = styled(CommonBoldText)`
	color: ${Colors.darkText};
	max-width: 400px;

	${Functions.breakpoint(Breakpoints.laptop)} {
		max-width: 600px;
	}
`;

const StyledLinkButton = styled(SquareButton)`
	margin-top: 30px;
`;

export default function ErrorPage() {
	// const language = Site.use(state => state.language);
	const global = Site.use(state => state.global);

	return (
		<StyledPage>
			<PageContent>
				<StyledCommonTitle>404</StyledCommonTitle>
				<StyledCommonText>{global.pageNotFoundText}</StyledCommonText>

				<StyledLinkButton colors={global.pageNotFoundLink[0].buttonColorLink} link={global.pageNotFoundLink[0].link[0]}>
					{global.pageNotFoundLink[0].link[0]?.title}
				</StyledLinkButton>
			</PageContent>
		</StyledPage>
	);
}
